<!--自采材料叫料管理-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form class="self-order-search-form" @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          slot="organizationCodeList"
          :value.sync="queryParams.organizationCodeList"
          selectType="selectAssembleMultiple"
          :selectData="inventOrg"
          :selectItem="{ value: 'realValue', label: 'label' }"
          :assembleLabel="true"
        />
        <global-select
          ref="materialSupplierListRef"
          slot="materialSupplierList"
          :value.sync="queryParams.materialSupplierList"
          selectType="selectAssembleMultipleFilter"
          requestApi="/scp/scpDirectDeliveryCallManager/callMaterialSupplierCombobox"
          :selectItem="{ value: 'realValue', label: 'label' }"
          searchParam="materialSupplier"
        />
        <global-select
          ref="wipStatusListRef"
          slot="wipStatusList"
          :value.sync="queryParams.wipStatusList"
          selectType="selectMultipleFilter"
          requestApi="/scp/scpDirectDeliveryCallManager/wipStatusCombobox"
          :selectItem="{ value: 'realValue', label: 'label' }"
          searchParam="wipStatus"
        />
        <a-input slot="wipEntityName" v-model="queryParams.wipEntityName" allowClear />
        <global-select
          ref="statusListRef"
          slot="statusList"
          :value.sync="queryParams.statusList"
          selectType="selectMultipleFilter"
          requestApi="/scp/scpDirectDeliveryCallManager/callStatusComboBox"
          :selectItem="{ value: 'realValue', label: 'label' }"
          searchParam="status"
          @successCallBack="getStatusList"
        />
      </ls-search-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="onUpdateCallDemand" type="primary" :loading="loading" v-hasPermi="['scp:scpDirectDeliverySelfCallManager:updateData']">更新叫料数据</a-button>
      <a-button @click="onCreateMaterial" type="primary" :loading="loading" v-hasPermi="['scp:scpDirectDeliverySelfCallManager:callMaterial']">叫料</a-button>
      <a-button @click="onCancelCall" :loading="loading" v-hasPermi="['scp:scpDirectDeliverySelfCallManager:cancel']">取消叫料</a-button>
      <a-button @click="onExport" :loading="loading" v-hasPermi="['scp:scpDirectDeliverySelfCallManager:export']">导出</a-button>
      <download-modal :apiFun="apiExportDirectDeliveryCaLL" ref="download" />
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          class="workOrderMaterialTableCss"
          ref="workOrderMaterialTable"
          :columns="columns"
          :tableProps="tableProps"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          rowKey="id"
          @selectedRowChange="selectedRowChange"
          :scroll="{ fixScreen: true, x: 1700 }"
        >
          <template slot="materialSupplier" slot-scope="{ record }">
            <span v-if="record.materialSupplier">{{ record.materialSupplier }}-{{ record.materialSupplierName }}</span>
          </template>
          <!-- 叫料状态 -->
          <template slot="statusName" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.id">{{ record.statusName }}</span>
            <a-select style="width: 100%" v-else v-model="record.status">
              <a-select-option v-for="(item) in editStatusList" :key="item.realValue">{{ item.label }}</a-select-option>
            </a-select>
          </template>
          <div slot="operation" slot-scope="{ text, record }" class="operation-btn">
            <!--未叫料才能编辑-->
            <a v-if="(!isEdit || currentId !== record.id)&&record.status === 'N'" @click="handleEdit(record)">编辑</a>
            <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
            <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
          </div>
        </ls-api-table>
        <create-order-material ref="createOrderMaterialRef" @successFun="onSearch" />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js'
import createOrderMaterial from '@/views/scp/factoryCallMaterial/selfOrderMaterial/components/create-order-material'
import { mapState } from 'vuex'
import cloneDeep from 'lodash.clonedeep'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import {
  apiCallManagerUpdateCallData,
  apiScpDirectDeliveryCallManager,
  apiExportDirectDeliveryCaLL,
  apiCallManagerCancelCall,
  apiCallManagerUpdateStatus
} from '@/api/scp/work-order-material/material-work-order-material'
import { LIST_COLUMNS } from '@/views/scp/factoryCallMaterial/selfOrderMaterial/enum'
import moment from 'moment'

export default {
  name: 'SelfOrderMaterial',
  components: {
    createOrderMaterial,
    DownloadModal
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  data () {
    return {
      isEdit: false,
      currentId: "",
      apiExportDirectDeliveryCaLL,
      editStatusList: [], // 状态
      formList: [
        { label: '加工厂', decorator: ['organizationCodeList'], type: 'organizationCodeList' },
        { label: '材料商', decorator: ['materialSupplierList'], type: 'materialSupplierList' },
        { label: '原材料-物料编码', decorator: ['rawMaterialCode'], type: 'input' },
        {
          label: '计划送货时间',
          type: 'range',
          decorator: ['planDeliveryTime'],
          disposeFormat: {
            planDeliveryTimeFrom: (change) => { return change[0].format('yyyy-MM-DD 00:00:00') },
            planDeliveryTimeTo: (change) => { return change[1].format('yyyy-MM-DD 23:59:59') }
          }
        },
        { label: '工单号', decorator: ['wipEntityName'], type: 'wipEntityName' },
        { label: '工单状态', decorator: ['wipStatusList'], type: 'wipStatusList' },
        { label: '物料编码', decorator: ['completedItemCode'], type: 'input' },
        { label: '状态', decorator: ['statusList'], type: 'statusList' },
        { label: '叫料单号', decorator: ['callDocNumber'], type: 'input' },
        {
          label: '计划完成时间',
          type: 'range',
          decorator: ['scheduledCompletionDate'],
          disposeFormat: {
            scheduledCompletionDateFrom: (change) => { return change[0].format('yyyy-MM-DD 00:00:00') },
            scheduledCompletionDateTo: (change) => { return change[1].format('yyyy-MM-DD 23:59:59') }
          }
        },
        {
          label: '一次达交考核时间',
          type: 'range',
          decorator: ['deliveryDate'],
          disposeFormat: {
            deliveryDateFrom: (change) => { return change[0].format('yyyy-MM-DD 00:00:00') },
            deliveryDateTo: (change) => { return change[1].format('yyyy-MM-DD 23:59:59') }
          }
        },
        {
          label: '要求到料时间',
          type: 'range',
          decorator: ['requiredDeliveryDate'],
          disposeFormat: {
            requiredDeliveryDateFrom: (change) => { return change[0].format('yyyy-MM-DD 00:00:00') },
            requiredDeliveryDateTo: (change) => { return change[1].format('yyyy-MM-DD 23:59:59') }
          }
        }
      ],
      loading: false,
      // 表格配置1
      tableProps: {
        requestApi: generateLsTableResData(apiScpDirectDeliveryCallManager, true),
        pageCurrent: true
      },
      // 查询参数
      queryParams: {
        organizationCodeList: [],
        materialSupplierList: [],
        rawMaterialCode: undefined,
        planDeliveryTime: undefined,
        planDeliveryTimeTo: undefined,
        planDeliveryTimeFrom: undefined,
        scheduledCompletionDate: undefined,
        scheduledCompletionDateTo: undefined,
        scheduledCompletionDateFrom: undefined,
        deliveryDate: undefined,
        deliveryDateTo: undefined,
        deliveryDateFrom: undefined,
        requiredDeliveryDate: undefined,
        requiredDeliveryDateTo: undefined,
        requiredDeliveryDateFrom: undefined,
        wipEntityName: undefined,
        wipEntityNameList: undefined,
        wipStatusList: [],
        completedItemCode: undefined,
        statusList: [],
        callDocNumber: undefined
      },
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      // 表格字段
      columns: LIST_COLUMNS
    }
  },
  mounted () {
    this.loading = false;
    this.$nextTick(() => {
      this.$refs.refSearchForm.form.setFieldsValue({ planDeliveryTime: [moment(), moment()] })
      this.onSearch(
        {
          planDeliveryTimeFrom: moment().format('YYYY-MM-DD 00:00:00'),
          planDeliveryTimeTo: moment().format('YYYY-MM-DD 23:59:59')
        }
      )
    })
  },
  methods: {
    // 兼容处理excel复制工单号
    onChangeWipEntity() {
      const wipEntityNameObj = {
        wipEntityName: '', // 单个/模糊工单号，只传这个
        wipEntityNameList: [] // 多个工单号，传这个
      }
      if (this.queryParams?.wipEntityName) {
        const list = this.queryParams.wipEntityName.split(' ')
        list.forEach((v, i) => {
          list[i] = v.replace(/[\n\r\s\W_]+/g, '') // 去掉excel可能存在的特殊字符
          if (list[i]) { wipEntityNameObj.wipEntityNameList.push(list[i]) }
        })
        if(wipEntityNameObj.wipEntityNameList?.length < 2) {
          wipEntityNameObj.wipEntityName = this.queryParams.wipEntityName.replace(/[\n\r\s\W_]+/g, '')
          wipEntityNameObj.wipEntityNameList = []
        }
      }
      return wipEntityNameObj
    },
    // 获取叫料状态
    getStatusList(data) {
      this.editStatusList = data.filter(item => ['N', 'WITHOUT'].includes(item.realValue))
    },
    // 新增/修改框事件, changePage为true，则不返回到第一页
    handleOk(changePage = false) {
      this.onSearch({ ...this.$refs.refSearchForm.getSearchValue() }, changePage)
    },
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 编辑-保存
    handleSave (record) {
      apiCallManagerUpdateStatus({ id: record.id, status: record.status }).then(res => {
        if (res?.code === 200) {
          this.$message.success('保存成功')
          this.handleOk(true)
        } else {
          this.$message.error(res?.msg || '保存失败')
        }
      })
    },
    // 取消
    handleCancel () {
      this.handleOk(true)
    },
    // 行选中
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    // 取消叫料
    onCancelCall() {
      if (this.selectedRows?.length < 1) {
        this.$message.warning('请勾选数据')
        return false
      }
      // 只有’已叫料‘和’驳回‘状态数据行才能取消叫料单号
      if(this.selectedRows.find(v => !(['Y', 'REJECTED'].includes(v.status)))) {
        this.$message.warning('请勾选已叫料、驳回单据取消')
        return false
      }
      this.loading = true;
      const ids = this.selectedRows.map(v => v.id)
      apiCallManagerCancelCall(ids).then((res) => {
        this.loading = false;
        if (res?.code === 200) {
          this.$message.success('操作成功')
          this.handleOk(false)
        } else {
          this.$message.error(res?.msg || '操作失败')
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 叫料
    onCreateMaterial() {
      if (this.selectedRows?.length < 1) {
        this.$message.warning('请勾选数据')
        return false
      }
      // 只有’未叫料‘’驳回‘’取消‘状态才能发起叫料
      if(this.selectedRows.find(v => !(['N', 'REJECTED', 'CANCEL'].includes(v.status)))) {
        this.$message.warning('请勾选未叫料、驳回、取消状态的数据')
        return false
      }
      this.$refs.createOrderMaterialRef.show(this.selectedRows)
    },
    // 导出工单叫料
    onExport() {
      const params = this.$refs?.workOrderMaterialTable?.searchParams
      this.$refs.download.openModal({ ...params, materialModel: '15' })
    },
    // 更新叫料需求
    onUpdateCallDemand() {
      this.loading = true;
      apiCallManagerUpdateCallData({ materialModel: '15' }).then((res) => {
        if (res?.code === 200) {
          this.$message.success(res?.data || '更新成功')
          this.handleOk(false)
        } else {
          this.$message.error(res?.msg)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 表单搜索
    onSearch (value = {}, changePage = false) {
      this.isEdit = false;
      this.currentId = '';
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      // 后端要求接口区分入参，materialModel为15是虚拟仓，materialModel为20为PMC直送
      let cloneParams = cloneDeep({ ...params, materialModel: '15' })
      if(this.queryParams?.wipEntityName) {
        const wipEntityNameObj = this.onChangeWipEntity(); // 判断是否要处理工单号
        cloneParams = Object.assign(cloneParams, wipEntityNameObj)
      }
      this.$refs.workOrderMaterialTable.searchParams = cloneParams;
      this.$refs.workOrderMaterialTable.getData(changePage);
    },
    // 重置按钮操作
    resetQuery () {
      this.queryParams = {
        organizationCodeList: [],
        materialSupplierList: [],
        rawMaterialCode: undefined,
        planDeliveryTime: undefined,
        planDeliveryTimeTo: undefined,
        planDeliveryTimeFrom: undefined,
        scheduledCompletionDate: undefined,
        scheduledCompletionDateTo: undefined,
        scheduledCompletionDateFrom: undefined,
        requiredDeliveryDate: undefined,
        requiredDeliveryDateTo: undefined,
        requiredDeliveryDateFrom: undefined,
        wipEntityName: undefined,
        wipEntityNameList: undefined,
        wipStatusList: [],
        completedItemCode: undefined,
        statusList: [],
        callDocNumber: undefined
      }
      this.onSearch()
    }
  }
}
</script>

<style scoped lang="less">
@import '../../../../components/StickyFixedSummary/styles/footerTable.less';
.workOrderMaterialTableCss{
  /deep/ .ant-table-tbody tr td {
    padding: 8px 8px;
  }
  /deep/ .ant-table-thead > tr > th {
    padding: 12px 8px;
  }
  /deep/ .ant-table-column-sort{
    background: #fff;
  }
}
/deep/.self-order-search-form .ant-col:nth-last-child(3) {
  .ant-form-item{
    .ant-form-item-label{
      width: 130px !important;
    }
    .ant-form-item-control-wrapper{
      max-width: 260px !important;
    }
  }
}

</style>
